
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.451 3.995H3.549c-.773 0-1.401.629-1.401 1.401v13.208c0 .773.628 1.401 1.401 1.401h16.902c.773 0 1.401-.629 1.401-1.401V5.396c0-.772-.628-1.401-1.401-1.401zm.785 14.609a.786.786 0 01-.785.785H3.549a.786.786 0 01-.785-.785V7.074h18.473v11.53zm0-12.146H2.764V5.396c0-.433.352-.785.785-.785h16.902c.433 0 .785.352.785.785v1.062z"}}),_c('path',{attrs:{"d":"M5.227 5.227H3.995a.308.308 0 000 .616h1.232a.308.308 0 000-.616z"}})])
          )
        }
      }
    